import findLastIndex from "lodash/findLastIndex";
import remove from "lodash/remove";
import uniqueId from "lodash/uniqueId";
import { GrowlProps } from "PFComponents/growl";
import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

import { GrowlPayload, GrowlStoreType } from "./growl_store_types";

const INITIAL_STATE = { growls: [] as GrowlStoreType["growls"] };

export const getGrowlId = (actionId: string, kind: GrowlProps["kind"] = "success") =>
  `${actionId}-${kind}-action`;

export const useGrowlStore = create<GrowlStoreType>()(
  immer((set) => ({
    ...INITIAL_STATE,
    actions: {
      showGrowl: (payload: GrowlPayload) =>
        set((state) => {
          if (payload.hidePreviousByTypeAndId) {
            const lastIdx = findLastIndex(state.growls, { kind: payload.kind, id: payload.id });
            if (lastIdx >= 0) {
              state.growls.splice(lastIdx, 1);
            }
          }

          const prevIndex = state.growls.findIndex((growl) => growl.id && growl.id === payload.id);
          const shouldReplaceContent = !payload.hidePreviousByTypeAndId && prevIndex >= 0;

          if (shouldReplaceContent) {
            state.growls[prevIndex].title = payload.title;
            state.growls[prevIndex].message = payload.message;
          } else {
            state.growls.push({
              id: uniqueId("growl"),
              timestamp: Date.now(),
              ...payload
            });
          }
        }),

      hideGrowl: (id: string) =>
        set((state) => {
          remove(state.growls, (growl) => growl.id === id);
        }),

      reset: () => set(INITIAL_STATE)
    }
  }))
);

export const useGrowlStoreActions = () => useGrowlStore((state) => state.actions);
